import React from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { Link } from "react-router-dom";
import { ModalInput } from "../ui-kit";

const Modal = ({
  isOpened,
  setOpened,
  icon,
  heading,
  content,
  noConfetti = false,
  linkOverride = null,
  buttonText = "Done",
}) => {
  return (
    <ModalInput
      isOpened={isOpened}
      onOutsideClick={() => {
        setOpened(false);
      }}
      overlayFrameClassName={"w-[500px] max-w-[80%]"}
    >
      <div className="p-8 text-center text-grigora-base">
        {!noConfetti && (
          <div className="flex items-center justify-center">
            <ConfettiExplosion zIndex={100000} height={1000} force={0.8} />
          </div>
        )}
        {icon}
        <h1 className="modal-heading mb-2">{heading}</h1>
        {content}
        <div className="text-center mt-5">
          <Link
            to={linkOverride || "/"}
            onClick={(e) => {
              setOpened(false);
            }}
            className="grigora-action-btn"
          >
            {buttonText}
          </Link>
        </div>
        <div className="text-center"></div>
      </div>
    </ModalInput>
  );
};

export default Modal;
